<template>
  <div @click="install">
    <Marketing id="auth" />
    <Install ref="install" />
    <WelcomeDialog ref="welcome" :handler="authDialog" />
  </div>
</template>
<script>
import Install from './popups/InstallDialog'
import WelcomeDialog from './popups/WelcomeDialog'
import Marketing from '../marketing/shoutu/Index'

export default {
  components: {
    WelcomeDialog,
    Marketing,
    Install
  },
  mounted () {
    if ($storage.get('NEWER')) {
      this.$refs.install.show()
    } else {
      this.$refs.welcome.show()
      $storage.set('NEWER', true)
    }
  },
  destroyed () {
    $storage.remove('NEWER')
  },
  methods: {
    install () {
      this.$refs.install.show()
    },
    authDialog () {
      this.$refs.welcome.hide()
      this.$refs.install.show()
    }
  }
}
</script>

